const getFullDate = ({ date, time }) => {
  const [day, month, year] = date.toString().split('.');
  const [hours, minutes] = time.toString().split(':');
  const dateString = `${year}/${month}/${day} ${hours}:${minutes}:00`;
  return new Date(dateString);
};

export default getFullDate;
